var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._l(_vm.informationGroups, function(informationGroup) {
        return _c(
          "div",
          { key: informationGroup.id, staticClass: "form-check" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedInformationGroupIds,
                  expression: "selectedInformationGroupIds"
                }
              ],
              staticClass: "form-check-input",
              attrs: {
                type: "checkbox",
                id: _vm._uid + "information" + informationGroup.id
              },
              domProps: {
                value: informationGroup.id,
                checked: Array.isArray(_vm.selectedInformationGroupIds)
                  ? _vm._i(
                      _vm.selectedInformationGroupIds,
                      informationGroup.id
                    ) > -1
                  : _vm.selectedInformationGroupIds
              },
              on: {
                change: function($event) {
                  var $$a = _vm.selectedInformationGroupIds,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = informationGroup.id,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        (_vm.selectedInformationGroupIds = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.selectedInformationGroupIds = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.selectedInformationGroupIds = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form-check-label",
                attrs: { for: _vm._uid + "information" + informationGroup.id }
              },
              [_vm._v("\n      " + _vm._s(informationGroup.name) + "\n    ")]
            )
          ]
        )
      }),
      _vm._v(" "),
      !_vm.informationGroups.length
        ? _c("div", [_vm._v("(" + _vm._s(_vm.$t("general.none")) + ")")])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }